import React from 'react'
import { Row, Col,notification,Card, Image } from 'antd'
import { RightOutlined  } from '@ant-design/icons';
import { Link } from 'react-router-dom'
import AppService from 'services/AppService';
import { useEffect } from 'react';
import moment from 'moment'
import { connect } from 'react-redux';
import {
    showAuthMessage,
    hideAuthMessage,
    getProfile,
    setLogo,
    setLogoActive
} from 'redux/actions/Auth';
import { API_BASE_URL } from 'configs/AppConfig';

function Profile(props) {
    const {  hideAuthMessage, showMessage } = props

    useEffect(() => {
        props.setLogo("/img/logo.png")
        props.setLogoActive(true)       
    }, [])

    useEffect(() => {
        if (showMessage) {
            setTimeout(() => {
                hideAuthMessage()
            }, 3000)
        }
    })
    return (
        <div className='main'>
            <div className='container'>
            <Row gutter={16} justify="center">
      <Col span={24} xl={20} xxl={18} >
        {/* <Button 
            style={{backgroundColor:'#1677ff',color:'#fff'}} 
            icon={<SelectOutlined className="mb-3" size={20} />}        
            href="/app"
            >
            Go Back
        </Button> */}
    <Row gutter={16} className="mt-4">
      <Col span={24} sm={12} >
      <Link to="/app/profile/edit-basic">
        <Card  hoverable="true">
            <Row gutter={16}>
              <Col span={6} className="d-flex justify-content-center align-items-center">
                <Image src="/img/settings/profile.png" preview={false} className="settings-card-img"/>
              </Col>
              <Col span={16} >
                <h2>Basic Information</h2>
                <h4 style={{color:'gray', fontWeight:'400'}}>Manage the Profile page's features and language. Set up your company details.</h4>
              </Col>
              <Col span={2} className="d-flex justify-content-center align-items-center">
                <RightOutlined style={{fontSize:'120%'}}/>
              </Col>
            </Row>
        </Card>
      </Link>
      </Col>
      <Col span={24} sm={12} >
      <Link to="/app/profile/edit-address">
          <Card hoverable="true">
              <Row gutter={16}>
                <Col span={6} className="d-flex justify-content-center align-items-center">
                  <Image src="/img/settings/company.png" preview={false}  className="settings-card-img"/>
                </Col>
                <Col span={16} >
                  <h2>Address</h2>
                  <h4 style={{color:'gray', fontWeight:'400'}}>Manage the Profile page's features and language. Set up your company details.</h4>
                </Col>
                <Col span={2} className="d-flex justify-content-center align-items-center">
                  <RightOutlined style={{fontSize:'120%'}}/>
                </Col>
              </Row>
          </Card>
        </Link>
      </Col>
      <Col span={24} sm={12} >
      <Link to="/app/profile/edit-experience">
        <Card  hoverable="true">
            <Row gutter={16}>
              <Col span={6} className="d-flex justify-content-center align-items-center">
                <Image src="/img/settings/career-page.png" preview={false} className="settings-card-img"/>
              </Col>
              <Col span={16} >
                <h2>Experience</h2>
                <h4 style={{color:'gray', fontWeight:'400'}}>Manage the Profile page's features and language. Set up your company details.</h4>
              </Col>
              <Col span={2} className="d-flex justify-content-center align-items-center">
                <RightOutlined style={{fontSize:'120%'}}/>
              </Col>
            </Row>
        </Card>
        </Link>
      </Col>
      <Col span={24} sm={12} >
      <Link to="/app/profile/edit-education">
        <Card  hoverable="true">
            <Row gutter={16}>
              <Col span={6} className="d-flex justify-content-center align-items-center">
                <Image src="/img/settings/social-links.png" preview={false} className="settings-card-img"/>
              </Col>
              <Col span={16} >
                <h2>Education</h2>
                <h4 style={{color:'gray', fontWeight:'400'}}>Manage the Profile page's features and language. Set up your company details.</h4>
              </Col>
              <Col span={2} className="d-flex justify-content-center align-items-center">
                <RightOutlined style={{fontSize:'120%'}}/>
              </Col>
            </Row>
        </Card>
        </Link>
      </Col>
      <Col span={24} sm={12} >
      <Link to="/app/profile/change-pass">
        <Card  hoverable="true">
            <Row gutter={16}>
              <Col span={6} className="d-flex justify-content-center align-items-center">
                <Image src="/img/settings/change-password.png" preview={false} className="settings-card-img"/>
              </Col>
              <Col span={16} >
                <h2>Change Password</h2>
                <h4 style={{color:'gray', fontWeight:'400'}}>Manage the Profile page's features and language. Set up your company details.</h4>
              </Col>
              <Col span={2} className="d-flex justify-content-center align-items-center">
                <RightOutlined style={{fontSize:'120%'}}/>
              </Col>
            </Row>
        </Card>
        </Link>
      </Col>
      {/* <Col span={24} sm={12} >
      <Link to="/app/website-integration">
        <Card  hoverable="true">
            <Row gutter={16}>
              <Col span={6} className="d-flex justify-content-center align-items-center">
                <Image src="/img/settings/website-integration.png" preview={false} className="settings-card-img"/>
              </Col>
              <Col span={16} >
                <h2>Website Integration</h2>
                <h4 style={{color:'gray', fontWeight:'400'}}>Manage the Profile page's features and language. Set up your company details.</h4>
              </Col>
              <Col span={2} className="d-flex justify-content-center align-items-center">
                <RightOutlined style={{fontSize:'120%'}}/>
              </Col>
            </Row>
        </Card>
        </Link>
      </Col> */}
      <Col span={24} sm={12} >
      <Link to="/app/support">
        <Card  hoverable="true">
            <Row gutter={16}>
              <Col span={6} className="d-flex justify-content-center align-items-center">
                <Image src="/img/settings/support.png" preview={false} className="settings-card-img"/>
              </Col>
              <Col span={16} >
                <h2>Support</h2>
                <h4 style={{color:'gray', fontWeight:'400'}}>Manage the Profile page's features and language. Set up your company details.</h4>
              </Col>
              <Col span={2} className="d-flex justify-content-center align-items-center">
                <RightOutlined style={{fontSize:'120%'}}/>
              </Col>
            </Row>
        </Card>
        </Link>
      </Col>
      {/* <Col span={24} sm={12} >
      <Link to="/app/subscription">
        <Card  hoverable="true">
            <Row gutter={16}>
              <Col span={6} className="d-flex justify-content-center align-items-center">
                <Image src="/img/settings/subscription.png" preview={false} className="settings-card-img"/>
              </Col>
              <Col span={16} >
                <h2>Subscription</h2>
                <h4 style={{color:'gray', fontWeight:'400'}}>Manage the Profile page's features and language. Set up your company details. </h4>
              </Col>
              <Col span={2} className="d-flex justify-content-center align-items-center">
                <RightOutlined style={{fontSize:'120%'}}/>
              </Col>
            </Row>
        </Card>
        </Link>
      </Col> */}
    </Row>
    </Col>
    </Row>
           </div>
        </div>
    )
}
const mapStateToProps = ({ auth }) => {
    const { message, showMessage } = auth
    return { message, showMessage }
}
const mapDispatchToProps = {
    showAuthMessage,
    hideAuthMessage,
    getProfile,
    setLogo,
    setLogoActive
}


export default connect(mapStateToProps, mapDispatchToProps)(Profile)
